{
  "RRSP": "Rrsp",
  "TFSA": "Tfsa",
  "PERSONAL": "Cash",
  "RESP": "Resp",
  "RESP_SINGLE": "Single Resp",
  "RESP_FAMILY": "Family Resp",
  "RESP_ADULT": "Adult RESP",
  "CORPORATE_CASH": "Corporate Cash",
  "CORPORATE_TRUST": "Trusts",
  "CORPORATE_ESTATE": "Corporate Estate",
  "CORPORATE_CHARITY": "Corporate Charity",
  "RRSP_SPOUSAL": "Spousal Rrsp",
  "LIRA": "Lira",
  "RRIF": "Rrif",
  "RIF_SPOUSAL": "Spousal Rrif",
  "LIF": "Lif",
  "PRIF": "Prif",
  "GRSP": "Grsp",
  "CASH_JOINT": "Joint Cash",
  "RDSP": "Rdsp",
  "RESP_SINGLE_JOINT": "RESP Single Joint",
  "RESP_FAMILY_JOINT": "RESP Family Joint",
  "ARTICLES_OF_INCORPORATION_OR_EQUIVALENT": "Articles Of Incorporation Or Equivalent",
  "BENEFICIARY_DESIGNATION_FORM": "Beneficiary Designation Form",
  "BENEFICIARY_RRSP": "Beneficiary Rrsp",
  "BENEFICIARY_TFSA": "Beneficiary Tfsa",
  "CLB_FOR_ADULTS": "Clb For Adults",
  "CLIENT_ACCOUNT_AGREEMENT": "Client Account Agreement",
  "CORPORATE_ACCOUNT_AGREEMENT": "Corporate Account Agreement",
  "CORPORATE_RESOLUTION": "Corporate Resolution",
  "DEATH_CERTIFICATE": "Death Certificate",
  "DECLARATION_OF_TAX_DISCLOSURE": "Declaration Of Tax Disclosure",
  "DECLARATION_OF_TAX_DISCLOSURE_E": "Declaration Of Tax Disclosure E",
  "DISCRETIONARY_MANAGEMENT_AGREEMENT": "Discretionary Management Agreement",
  "EDUCATION_SAVINGS_GRANTS_APPLICATION": "Education Savings Grants Application",
  "ELECTRONIC_DELIVERY_AGREEMENT": "Electronic Delivery Agreement",
  "EXTERNAL_TRANSFER_TO_NON_REGISTERED_ACCOUNTS": "External Transfer To Non Registered Accounts",
  "EXTERNAL_TRANSFER_TO_REGISTERED_ACCOUNTS": "External Transfer To Registered Accounts",
  "FEE_REDIRECTION": "Fee Redirection",
  "FHSA": "Fhsa",
  "GOAL_INVESTMENT_POLICY_STATEMENT": "Goal Investment Policy Statement",
  "INVESTMENT_POLICY_STATEMENT": "Investment Policy Statement",
  "JOINT_CLIENT_ACCOUNT_AGREEMENT": "Joint Client Account Agreement",
  "LAST_WILL": "Last Will",
  "LIF_ADDENDUM": "Lif Addendum",
  "LIRA_ADDENDUM": "Lira Addendum",
  "LOD_QESI": "Lod Qesi",
  "LRIF": "Lrif",
  "LRIF_ADDENDUM": "Lrif Addendum",
  "LRSP": "Lrsp",
  "LRSP_ADDENDUM": "Lrsp Addendum",
  "NON_INDIVIDUAL_ENTITY_ACCOUNT_AGREEMENT": "Non Individual Entity Account Agreement",
  "ONEVEST_RELATIONSHIP_DISCLOSURE_BROCHURE": "Onevest Relationship Disclosure Brochure",
  "PAD_AGREEMENT": "Pad Agreement",
  "PRIF_ADDENDUM": "Prif Addendum",
  "RESP_FAMILY_PLAN": "Resp Family Plan",
  "RESP_SINGLE_PLAN": "Resp Single Plan",
  "RLIF": "Rlif",
  "RLIF_ADDENDUM": "Rlif Addendum",
  "RLSP": "Rlsp",
  "RLSP_ADDENDUM": "Rlsp Addendum",
  "SWP_AGREEMENT": "Swp Agreement",
  "TRUST_AGREEMENT": "Trust Agreement",
  "TRUST_DEED": "Trust Deed",
  "TRUST_PARTICIPANT_IDENTIFICATION_FORM": "Trust Participant Identification Form",
  "W8BEN": "W8Ben",
  "W9": "W9",
  "WAIVER_OF_CONFIDENTIALITY": "Waiver Of Confidentiality",
  "W_8BEN_E": "W_8BenE",
  "W_8IMY": "W_8Imy"
}
